'use-strict';

// Answer Tick SVG
const tickSvg = "<svg class='tick' xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'><path d='M6.66647 10.1139L12.7947 3.98568L13.7375 4.92849L6.66647 11.9995L2.42383 7.75693L3.36664 6.81413L6.66647 10.1139Z' fill='#111111'/></svg>";

// Selectors
const body = document.body;
const landingContainer = document.querySelector('.surveylanding-container');
const mainHeader = document.querySelector('header.header');
const questionsContainer = document.getElementById('questions-container');
const surveySection = document.getElementById('survey');
const surveyHeader = surveySection ? surveySection.querySelector('.header-bar') : null;
const startButton = landingContainer ? landingContainer.querySelector('.primary-button.start-button') : null;
const finalMessage = document.getElementById('final-message');
const progressBar = document.getElementById('progress-bar');
const backButton = document.getElementById('back-button');
const closeButton = document.getElementById('x-button');

// Variables
const DEFAULT_ANIMATION_SPEED = surveySection ? surveySection.dataset.animationsSpeed : 500;
const DEFAULT_SPLASH_SPEED = surveySection ? surveySection.dataset.splashSpeed : 2000;
const GIFT_FINDER_PLP_BASE_URL = surveySection ? surveySection.dataset.plpBaseUrl : null;
let userResponses = [];
let questions = {};
let stepOfTranslation = '';
let questionsObj = null;
let currentStep = 0;
let totalQuestions = null

function renderAllQuestions() {
  totalQuestions = questions.length;

  if (questionsContainer && questionsContainer.childNodes.length === 0) {
    questions.forEach((question, index) => {
      const questionDiv = document.createElement('div');
      questionDiv.classList.add('question');
      questionDiv.setAttribute('id', 'question-' + index);
      questionDiv.setAttribute('data-bg-image', question.bgImage);
      questionDiv.style.display = index === 0 ? 'block' : 'none';

      const questionNumber = document.createElement('div');
      questionNumber.classList.add('question-number');
      questionNumber.innerText = (index + 1) + " " + stepOfTranslation + " " + totalQuestions;
      questionDiv.appendChild(questionNumber);

      const questionTitle = document.createElement('div');
      questionTitle.classList.add('question-title');
      questionTitle.innerText = question.questionContent;
      questionDiv.appendChild(questionTitle);

      question.answers.forEach((answer, answerIndex) => {
          const answerButton = document.createElement('button');
          answerButton.innerText = answer.trim();
          answerButton.classList.add('answerButton');
          answerButton.innerHTML += tickSvg;

          answerButton.addEventListener('click', () => handleAnswerClick(answerButton, questionDiv, index, answerIndex));

          questionDiv.appendChild(answerButton);
      });

      questionsContainer.appendChild(questionDiv);
    });
  }

  showQuestion(currentStep);
}

function showQuestion(step, direction = 'forward') {
  surveyHeader.style.transform = 'translateY(0)';
  const questions = document.querySelectorAll('.question');
  questions.forEach((q, index) => {
    if (index === step) {
      if (q.dataset.bgImage && q.dataset.bgImage !== '') {
        questionsContainer.style.backgroundImage = 'url('+q.dataset.bgImage+')';
      }
      
      if (direction === 'forward') {
        slideInFromBottom(q);
      } else {
        slideInFromTop(q);
      }
    } else {
      if (direction === 'forward') {
        slideOutToTop(q);
      } else {
        slideOutToBottom(q);
      }
    }
  });

  document.getElementById('back-button').style.display = (step > 0) ? 'flex' : 'none';
}

function handleAnswerClick(answerButton, questionDiv, step, index) {
  const answerButtons = questionDiv.querySelectorAll('.answerButton');
  answerButtons.forEach(a => a.classList.remove('selected'));
  answerButton.classList.add('animate-border');
  answerButtons.forEach(a => a.disabled = true);

  userResponses[step] = { question: step + 1, answer: String.fromCharCode(65 + index) };
  
  if (step < (questions.length -1)) {
    setTimeout(() => {
      answerButton.classList.remove('animate-border');
      answerButton.classList.add('selected');

      updateProgressBar();
      toggleBackButton();
  
      currentStep++;
      showQuestion(currentStep);
    }, DEFAULT_ANIMATION_SPEED);
  } else {
    setTimeout(() => {
      answerButton.classList.remove('animate-border');
      answerButton.classList.add('selected');
      updateProgressBar();
      showFinalMessage();
    }, DEFAULT_ANIMATION_SPEED);
  }
}

function handleBackButtonClick() {
  if (currentStep > 0) {
    currentStep--;
    const questionDiv = document.getElementById('question-' + currentStep);
    const answerButtons = questionDiv.querySelectorAll('.answerButton');
    answerButtons.forEach(a => a.disabled = false);
    updateProgressBar();
    showQuestion(currentStep, 'backward');
  }
}

if (startButton) {
  startButton.addEventListener('click', function (e) {
      e.preventDefault();
      slideOutToTop(mainHeader);
      slideInFromBottom(progressBar);
      body.classList.add('no-scroll');
      mainHeader.style.display = 'none';
      surveySection.classList.add('started');
      slideOutToBottom(landingContainer);

      setTimeout(() => {
        slideInFromTop(surveyHeader);
        surveyHeader.style.transform = 'translateY(0)';
        surveyHeader.style.display = 'flex';

        if (!questionsObj) {
            questionsObj = JSON.parse(questionsContainer.dataset.questions);
            stepOfTranslation = questionsContainer.dataset.stepTranslation;
            questionsContainer.removeAttribute('data-questions');
            questionsContainer.removeAttribute('data-step-translation');
        }
        questions = questionsObj.questions;
        renderAllQuestions();
        fadeIn(questionsContainer);
      }, 800);

      if (closeButton) {
        closeButton.disabled = false;
        closeButton.addEventListener('click', function() {
          body.classList.remove('no-scroll');
          questionsContainer.style.display = 'none';
          fadeOut(questionsContainer);
  
          surveySection.querySelectorAll('.answerButton').forEach(a => {
            a.classList.remove('selected');
            a.disabled = false; 
          });
          slideOutToBottom(progressBar);
          currentStep = 0;
          updateProgressBar();

          slideOutToTop(surveyHeader);
        
          setTimeout(() => {
            questionsContainer.style.display = 'flex';
            mainHeader.style.display = 'block';
            slideInFromTop(mainHeader);
            mainHeader.style.position = window.innerWidth < 992 ? 'fixed' : 'sticky';
            finalMessage.classList.remove('active');

            surveySection.classList.remove('started');
            slideInFromBottom(landingContainer);
            userResponses = [];

            const surveyAnimationEndEvt = new CustomEvent('survey:animationend', {});
            body.dispatchEvent(surveyAnimationEndEvt);
          }, 800)
        });
      }
  });
}

body.addEventListener('survey:animationend', () => {
  if (startButton) {
    setTimeout(() => {
      startButton.focus();
      window.scrollTo(0, 0);
    }, 100)
  }
});

if (backButton) {
  backButton.addEventListener('click', handleBackButtonClick);
}

function showFinalMessage() {
  questionsContainer.style.display = 'none';
  surveyHeader.style.display = 'none';
  finalMessage.classList.add('active');
  
  const marniLetters = finalMessage.querySelectorAll('.marni-logo');
  animateLetters(marniLetters);

  let responseString = ''
  userResponses.forEach(resp => responseString += resp.answer.toLowerCase());

  setTimeout(() => {
    if (GIFT_FINDER_PLP_BASE_URL && responseString && responseString !== '') {
      window.location = GIFT_FINDER_PLP_BASE_URL + responseString;
    }
  }, DEFAULT_SPLASH_SPEED)
}

function animateLetters(letters) {
    let index = 0;

    function addRedClass() {
        if (index < letters.length) {
            letters[index].classList.add('red');
            index++;
            setTimeout(addRedClass, 400);
        } else {
            setTimeout(resetAll, 400); 
        }
    }

    function resetAll() {
        letters.forEach(letter => letter.classList.remove('red'));
        setTimeout(animateLetters(letters), 1000);
    }

    setTimeout(() => {
      addRedClass();
    }, 400)
}

function fadeIn(element, duration = 500) {
  element.style.visibility = "visible";
  element.style.position = "relative";
  element.style.opacity = 0;
  let start = null;

  function step(timestamp) {
      if (!start) start = timestamp;
      let progress = timestamp - start;
      element.style.opacity = Math.min(progress / duration, 1);
      if (progress < duration) {
          window.requestAnimationFrame(step);
      }
  }

  window.requestAnimationFrame(step);
}

function fadeOut(element, duration = 500) {
  element.style.opacity = 1;
  let start = null;

  function step(timestamp) {
      if (!start) start = timestamp;
      let progress = timestamp - start;
      element.style.opacity = Math.max(1 - progress / duration, 0);
      
      if (progress < duration) {
          window.requestAnimationFrame(step);
      } else {
        element.style.visibility = "hidden";
        element.style.position = "absolute";
      }
  }
  window.requestAnimationFrame(step);
}

function slideInFromBottom(element, duration = 500) {
  element.style.display = "block";
  element.style.visibility = "visible";
  element.style.opacity = 0;
  element.style.transform = "translateY(100%)";
  let start = null;

  function step(timestamp) {
    if (!start) start = timestamp;
    let progress = timestamp - start;
    element.style.opacity = Math.min(progress / duration, 1);
    element.style.transform = `translateY(${Math.max(100 - (progress / duration) * 100, 0)}%)`;
    if (progress < duration) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

function slideInFromTop(element, duration = 500) {
  element.style.display = "block";
  element.style.visibility = "visible";
  element.style.opacity = 0;
  element.style.transform = "translateY(-100%)";
  let start = null;

  function step(timestamp) {
    if (!start) start = timestamp;
    let progress = timestamp - start;
    element.style.opacity = Math.min(progress / duration, 1);
    element.style.transform = `translateY(${Math.max(-100 + (progress / duration) * 100, 0)}%)`;
    if (progress < duration) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

function slideOutToTop(element, duration = 500) {
  element.style.opacity = 1;
  element.style.transform = "translateY(0)";
  let start = null;

  function step(timestamp) {
    if (!start) start = timestamp;
    let progress = timestamp - start;
    element.style.opacity = Math.max(1 - progress / duration, 0);
    element.style.transform = `translateY(${-(progress / duration) * 100}%)`;
    if (progress < duration) {
      window.requestAnimationFrame(step);
    } else {
      element.style.visibility = "hidden";
      element.style.position = "absolute";
    }
  }

  window.requestAnimationFrame(step);
}

function slideOutToBottom(element, duration = 500) {
  element.style.opacity = 1;
  element.style.transform = "translateY(0)";
  let start = null; 

  function step(timestamp) {
    if (!start) start = timestamp;
    let progress = timestamp - start;
    element.style.opacity = Math.max(1 - progress / duration, 0);
    element.style.transform = `translateY(${(progress / duration) * 100}%)`;
    if (progress < duration) {
      window.requestAnimationFrame(step);
    } else {
      element.style.visibility = "hidden";
      element.style.position = "absolute";
    }
  }

  window.requestAnimationFrame(step);
}

function updateProgressBar() {
  const progressBarFill = document.getElementById('progress-bar-fill');
  const progressPercentage = ((currentStep+1) / totalQuestions) * 100;
  progressBarFill.style.width = `${progressPercentage}%`;
}

function toggleBackButton() {
  const backButton = document.getElementById('back-button');
  backButton.disabled = currentStep === 0;
}

window.addEventListener('resize', () => {
  const isMobile = () => window.innerWidth < 992;
  if(landingContainer && !isMobile()) {
    const mainHeader = document.querySelector('header.header');
    let imgContainer = landingContainer.querySelector('.img-container');
    let actionContainer = landingContainer.querySelector('.actions-container');
  
    let headerHeight = mainHeader.clientHeight;
    imgContainer.setAttribute('style', 'max-height: '+(window.innerHeight-headerHeight)+'px !important');
    actionContainer.setAttribute('style', 'max-height: '+(window.innerHeight-headerHeight)+'px !important');
    mainHeader.style.position = 'sticky';
  } else if (landingContainer && isMobile()) {
    const mainHeader = document.querySelector('header.header');
    let imgContainer = landingContainer.querySelector('.img-container');
    let actionContainer = landingContainer.querySelector('.actions-container');
    imgContainer.removeAttribute('style');
    actionContainer.removeAttribute('style');
    mainHeader.style.position = 'fixed';
  }
});